import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './button.module.scss';

export class Button extends React.PureComponent {
  static propTypes = {
    type: PropTypes.string,
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    version: PropTypes.oneOf(['round', 'square']),
    color: PropTypes.oneOf(['turquoise', 'red']),
    children: PropTypes.node,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object,
  };

  static defaultProps = {
    type: 'button',
    variant: 'primary',
    version: 'round',
    children: null,
    disabled: false,
    className: '',
    onClick: () => {},
    style: {},
  };

  button = React.createRef();

  state = {
    mousePressed: false,
  };

  setClickedState = () => {
    this.setState({ mousePressed: true });
  };

  unsetClickedState = () => {
    this.setState({ mousePressed: false });
  };

  render() {
    const {
      children,
      type,
      variant,
      version,
      color,
      disabled,
      className,
      onClick,
      style,
      testId,
    } = this.props;

    const { mousePressed } = this.state;

    return (
      <button
        style={style}
        disabled={disabled}
        onClick={onClick}
        className={classnames(
          'button',
          styles[variant],
          styles['version-' + version],
          styles['color-' + color],
          className,
          {
            _pressed: mousePressed,
          },
        )}
        test-id={testId}
        data-testid={testId}
        type={type}
        ref={this.button}
        onMouseDown={this.setClickedState}
        onMouseUp={this.unsetClickedState}
        onMouseLeave={this.unsetClickedState}
      >
        {children}
      </button>
    );
  }
}
